import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'app-domain-name-transition',
    templateUrl: './domain-name-transition-dialog.component.html',
    styleUrl: './domain-name-transition-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DomainNameTransitionDialogComponent {
 @Input() targetUrl:string
}
